import VConsole from 'vconsole';
import styles from "./Breadcrumb.module.scss";
import React from "react";
import { useHistory } from "react-router-dom";

interface Props {
  step: number,
  children?: React.ReactNode;
  showText?: boolean;
  text?: string;
}
// let clickCount = 0;
function Breadcrumb({ step, children, showText = true, text }: Props) {
  const isDebugMode = ['dev', 'test'].includes(process.env.REACT_APP_HOST_TYPE as string);
  const isLocalhost = window.location.hostname.indexOf("localhost") > -1;
  // const isShowStepGuide = sessionStorage.getItem('isShowStepGuide') === 'SHOW';
  const history = useHistory();

  // const showDebug = () => {
  //   clickCount +=1;
  //   if (clickCount >= 6) {
  //     new VConsole();
  //     clickCount = 0;
  //   }
  // }
  const goToTestPage = () => {
    history.push("/recommend_test");
  }

  return (
    <div className={styles.Container}>
      {/* {!isShowStepGuide && (
        <div className={styles.ProcessBar}>
        {step === 1 && <div className={styles.ProcessComplete_1}/>}
        {step === 2 && <div className={styles.ProcessComplete_2} />}
        {step === 3 && <div className={styles.ProcessComplete_3} />}
      </div>
      )} */}

      {/* {step === 1 && showText && !isShowStepGuide &&
      <div className={styles.Breadcrumb} style={{ position: 'relative' }}>
          <div className={styles.innerPortal} onClick={showDebug}></div>
          您想要什么样的衣柜？
          {(isDebugMode || isLocalhost) &&
            <div className={styles.testRecommend} onClick={goToTestPage}>测试内配方案推荐结果</div>
          }
      </div>} */}
      {step === 1 && showText && (isDebugMode || isLocalhost) && (
        <div className={styles.Breadcrumb} style={{ position: 'relative' }}>
          <div className={styles.testRecommend} onClick={goToTestPage}>测试内配方案推荐结果</div>
        </div>
      )}
      {/* {step === 1 && showText && isShowStepGuide && (isDebugMode || isLocalhost) && (
        <div className={styles.Breadcrumb} style={{ position: 'relative' }}>
          <div className={styles.testRecommend} onClick={goToTestPage}>测试内配方案推荐结果</div>
        </div>
      )} */}

      {step !== 1 && showText &&
      <div className={styles.Breadcrumb}>
          <span>{text}</span>
      </div>}

      {children}
    </div>)
}

export default Breadcrumb;
